exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.new-dashboard[data-v-1f797000] {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  grid-template-rows: 430px auto;\n  grid-column-gap: 20px;\n  grid-row-gap: 20px;\n  min-height: calc(100vh - 100px);\n}\n.new-dashboard__wallet-widget[data-v-1f797000] {\n    grid-area: 1/1/2/5;\n}\n.new-dashboard__operations-widget[data-v-1f797000] {\n    grid-area: 1/5/2/9;\n}\n.new-dashboard__chart-widget[data-v-1f797000] {\n    grid-area: 1 / 9 / 2 / 13;\n}\n.new-dashboard__history-widget[data-v-1f797000] {\n    grid-area: 2 / 1 / 3 / 13;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f797000","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/dashboard/index/Dashboard.Index.vue
// module id = HjFV
// module chunks = 1